module.exports = __webpack_public_path__ + "static/media/world-cup-branding.5fe36b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/world-cup-branding.png
// module id = 219
// module chunks = 0